// App.js
import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';

// Import your components
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ScenarioList from './components/ScenarioList';
import ScenarioEditor from './components/ScenarioEditor';
import AppList from './components/AppList';
import AppEditor from './components/AppEditor';
import ScanHistory from './components/ScanHistory';
import AccountSettings from './components/AccountSettings';
import Layout from './components/Layout';

// Initialize Supabase client
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabase = createClient(supabaseUrl, supabaseKey);

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
      }
    );

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={!session ? <Login supabase={supabase} /> : <Navigate to="/" />} 
        />
        
        {/* Protected routes */}
        <Route element={<Layout session={session} supabase={supabase} />}>
          <Route path="/" element={session ? <Dashboard supabase={supabase} /> : <Navigate to="/login" />} />
          <Route path="/scenarios" element={session ? <ScenarioList supabase={supabase} /> : <Navigate to="/login" />} />
          <Route path="/scenarios/new" element={session ? <ScenarioEditor supabase={supabase} /> : <Navigate to="/login" />} />
          <Route path="/scenarios/:id" element={session ? <ScenarioEditor supabase={supabase} /> : <Navigate to="/login" />} />
          <Route path="/apps" element={session ? <AppList supabase={supabase} /> : <Navigate to="/login" />} />
          <Route path="/apps/new" element={session ? <AppEditor supabase={supabase} /> : <Navigate to="/login" />} />
          <Route path="/apps/:id" element={session ? <AppEditor supabase={supabase} /> : <Navigate to="/login" />} />
          <Route path="/history" element={session ? <ScanHistory supabase={supabase} /> : <Navigate to="/login" />} />
          <Route path="/account" element={session ? <AccountSettings supabase={supabase} /> : <Navigate to="/login" />} />
        </Route>
        
        {/* Fallback for unknown routes */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;